// extracted by mini-css-extract-plugin
export default {"contentGridItem":"h8sr70","subheading":"RMV1hM","heading":"MzvEas","root":"xp8t03","cta":"QSLUDa","googleReviewsLink":"_WAPmD"};